<div class="card-custom">
  <div class="card-custom__image--1">
    <img src="{{ cardData.thumbnail_url }}" alt="" />
  </div>
  <div class="card-custom__title">{{ cardData.title }}</div>
</div>
